module.exports = __webpack_public_path__ + "static/img/expand-arrow.d8549d3.svg";